const { registerBlockType } = wp.blocks;
const {
  RichText,
  RichTextToolbarButton,
  URLInputButton,
  MediaUpload,
  MediaUploadCheck,
  InspectorControls,
} = wp.blockEditor;
const {
  Button,
  Icon,
  PanelBody,
  SelectControl,
  ToggleControl,
  TextareaControl,
} = wp.components;
const { Fragment, useState, useEffect } = wp.element;
import { Modal } from '@wordpress/components';
const { __ } = wp.i18n;
import TinyMCEEditor from '../utils/tinmyce-editor';

const DEFAULT_IMAGE =
  '/wp-content/themes/positiongreen/resources/images/placeholders/placeholder_7.png';

import PgButton from '../utils/pg-button';
import PgImageUploaderPopover from '../utils/pg-image';

const BannerEdit = ({ attributes, setAttributes }) => {
  const {
    banners,
    topEnabled,
    topTitle,
    topDescription,
    sectionClass,
    cornerPositionClass,
    cornerBackgroundClass,
  } = attributes;

  const darkMode = sectionClass.includes('light');

  const addBanner = (type) => {
    const newBanners = [
      ...banners,
      {
        type,
        eyebrow: '<p></p>',
        title: '',
        description: '<p></p>',
        imgUrl: DEFAULT_IMAGE,
        imgAlt: '',
        contentPosition: 'content-left-center',
        buttons: [
          {
            text: 'Learn more',
            href: '#',
            className: 'btn btn-solid',
          },
        ],
        mobileImgUrl: DEFAULT_IMAGE,
        mobileImgAlt: '',
      },
    ];
    setAttributes({ banners: newBanners });
  };

  const removeBanner = (index) => {
    const newBanners = banners.filter((_, i) => i !== index);
    setAttributes({ banners: newBanners });
  };

  const updateBanner = (index, updates) => {
    const newBanners = banners.map((banner, i) => {
      if (i === index) {
        return { ...banner, ...updates };
      }
      return banner;
    });
    setAttributes({ banners: newBanners });
  };

  const updateButton = (index, buttonIndex, updates) => {
    const newButtons = [...banners[index].buttons];
    newButtons[buttonIndex] = { ...newButtons[buttonIndex], ...updates };
    updateBanner(index, { buttons: newButtons });
  };

  const removeButton = (index, buttonIndex) => {
    const newButtons = [...banners[index].buttons].filter(
      (_, i) => i !== buttonIndex
    );
    updateBanner(index, { buttons: newButtons });
  };

  const getBannerContent = (banner, index) => {
    const bannerClasses = {
      'banner-full': `banner banner-full ${banner.contentPosition}`,
      'banner-col-1': `banner banner-col-1 ${banner.contentPosition}`,
      'banner-col-2': `banner banner-col-2 ${banner.contentPosition}`,
    };

    return (
      <div className={bannerClasses[banner.type]} key={index}>
        <img
          className={'pg-banners-img-desktop'}
          src={
            banner.imgUrl && banner.imgUrl.length
              ? banner.imgUrl
              : DEFAULT_IMAGE
          }
          alt={
            banner.imgAlt && banner.imgAlt.length ? banner.imgAlt : banner.title
          }
        />
        <img
          className={'pg-banners-img-mobile'}
          src={
            banner.mobileImgUrl && banner.mobileImgUrl.length
              ? banner.mobileImgUrl
              : banner.imgUrl && banner.imgUrl.length
                ? banner.imgUrl
                : DEFAULT_IMAGE
          }
          alt={
            banner.mobileImgAlt && banner.mobileImgAlt.lengh
              ? banner.mobileImgAlt
              : banner.imgAlt && banner.imgAlt.length
                ? banner.imgAlt
                : banner.title
          }
        />

        <PgImageUploaderPopover
          desktopImage={banner.imgUrl}
          mobileImage={banner.mobileImgUrl}
          desktopImageAlt={banner.imgAlt}
          mobileImageAlt={banner.mobileImgAlt}
          desktopImageKey={'imgUrl'}
          desktopImageAltKey={'imgAlt'}
          mobileImageKey={'mobileImgUrl'}
          mobileImageAltKey={'mobileImgAlt'}
          onUpdate={(data) => updateBanner(index, data)}
        />
        <div className="content">
          <RichText
            tagName="div"
            className="h2-eyebrow"
            value={banner.eyebrow}
            onChange={(eyebrow) => updateBanner(index, { eyebrow })}
            placeholder={__('Enter eyebrow...')}
          />
          <RichText
            tagName="h2"
            value={banner.title}
            onChange={(title) => updateBanner(index, { title })}
            placeholder={__('Enter title...')}
          />
          <TinyMCEEditor
            value={banner.description}
            onChange={(description) => updateBanner(index, { description })}
          />
          <div className="buttons">
            {banner.buttons &&
              banner.buttons.map((button, bIndex) => (
                <Fragment key={bIndex}>
                  <PgButton
                    link={button.href}
                    label={button.text}
                    buttonClass={button.className}
                    onUpdate={(object) => updateButton(index, bIndex, object)}
                    onRemove={() => removeButton(index, bIndex)}
                    linkField={'href'}
                    labelField={'text'}
                    buttonClassField={'className'}
                  />
                </Fragment>
              ))}
            <div className={'full-width mt-16'}>
              <Button
                isSmall
                isSecondary
                className="addButton"
                onClick={() => {
                  const newButtons = [
                    ...(banner.buttons ?? []),
                    {
                      text: 'New Button',
                      href: '#',
                      className: 'btn btn-solid',
                    },
                  ];
                  updateBanner(index, { buttons: newButtons });
                }}
              >
                {__('+ Add Button', 'pg')}
              </Button>
            </div>
          </div>
        </div>
        <SelectControl
          label={__('Content Position')}
          className={'topMiddleButton'}
          value={banner.contentPosition}
          options={[
            { label: 'Center', value: 'content-center' },
            { label: 'Center Top', value: 'content-center-top' },
            { label: 'Left Top', value: 'content-left-top' },
            { label: 'Left Center', value: 'content-left-center' },
            { label: 'Left Bottom', value: 'content-left-bottom' },
            { label: 'Right Top', value: 'content-right-top' },
            { label: 'Right Center', value: 'content-right-center' },
            { label: 'Right Bottom', value: 'content-right-bottom' },
          ]}
          onChange={(newPosition) =>
            updateBanner(index, { contentPosition: newPosition })
          }
        />
        <Button
          isSmall
          isPrimary
          onClick={() => removeBanner(index)}
          className="removeStaticButton rightBottomButton"
        >
          <Icon icon="no-alt" /> {__('Remove Banner')}
        </Button>
      </div>
    );
  };

  const onChangeSectionClass = (newClass) => {
    setAttributes({ sectionClass: newClass });
  };

  const onChangeCornerPositionClass = (newClass) => {
    setAttributes({ cornerPositionClass: newClass });
  };

  const onChangeCornerBackgroundClass = (newClass) => {
    setAttributes({ cornerBackgroundClass: newClass });
  };

  return (
    <Fragment>
      <InspectorControls>
        <PanelBody title={__('Banner Settings')}>
          <ToggleControl
            label={__('Enable Top Section')}
            checked={topEnabled}
            onChange={() => setAttributes({ topEnabled: !topEnabled })}
          />
          <Button isPrimary onClick={() => addBanner('banner-full')}>
            <Icon icon="insert" /> {__('Add Full Banner')}
          </Button>
          <Button isPrimary onClick={() => addBanner('banner-col-1')}>
            <Icon icon="insert" /> {__('Add Column 1 Banner')}
          </Button>
          <Button isPrimary onClick={() => addBanner('banner-col-2')}>
            <Icon icon="insert" /> {__('Add Column 2 Banner')}
          </Button>
          <SelectControl
            label={__('Section Class')}
            value={sectionClass}
            options={[
              { label: 'Dark Secondary', value: 'section-dark-secondary' },
              { label: 'Dark Primary', value: 'section-dark-primary' },
              { label: 'Light Primary', value: 'section-light-primary' },
              { label: 'Light Secondary', value: 'section-light-secondary' },
            ]}
            onChange={onChangeSectionClass}
          />
          <SelectControl
            label={__('Corner Position')}
            value={cornerPositionClass}
            options={[
              { label: 'None', value: 'corner-disabled' },
              { label: 'Left-Top', value: 'corner-left-top' },
              { label: 'Left-Bottom', value: 'corner-left-bottom' },
              { label: 'Right-Top', value: 'corner-right-top' },
              { label: 'Right-Bottom', value: 'corner-right-bottom' },
            ]}
            onChange={onChangeCornerPositionClass}
          />
          <SelectControl
            label={__('Corner Background')}
            value={cornerBackgroundClass}
            options={[
              { label: 'Dark Primary', value: 'corner-on-dark-primary' },
              { label: 'Dark Secondary', value: 'corner-on-dark-secondary' },
              { label: 'Light Primary', value: 'corner-on-light-primary' },
              { label: 'Light Secondary', value: 'corner-on-light-secondary' },
            ]}
            onChange={onChangeCornerBackgroundClass}
          />
        </PanelBody>
      </InspectorControls>
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${sectionClass.replace(
            'section',
            'corner'
          )} ${cornerBackgroundClass}`}
        ></div>
        <div className="banners-section-wrapper">
          <div className="content-container">
            {topEnabled && (
              <div className="top">
                <RichText
                  tagName="h2"
                  value={topTitle}
                  onChange={(title) => setAttributes({ topTitle: title })}
                  placeholder={__('Enter top title...')}
                />
                <RichText
                  tagName="div"
                  className="description"
                  value={topDescription}
                  onChange={(description) =>
                    setAttributes({ topDescription: description })
                  }
                  placeholder={__('Enter top description...')}
                  allowedFormats={[
                    'core/bold',
                    'core/italic',
                    'core/link',
                    'core/list',
                  ]}
                />
              </div>
            )}
            <div className="banners-wrapper">
              {banners.map((banner, index) => getBannerContent(banner, index))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

registerBlockType('pg/banners', {
  title: 'PG Banners',
  icon: 'welcome-widgets-menus',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    banners: {
      type: 'array',
      default: [],
    },
    topEnabled: {
      type: 'boolean',
      default: false,
    },
    topTitle: {
      type: 'string',
      default: '',
    },
    topDescription: {
      type: 'string',
      default: '',
    },
    sectionClass: {
      type: 'string',
      default: 'section-dark-secondary',
    },
    cornerPositionClass: {
      type: 'string',
      default: 'corner-disabled',
    },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-dark-secondary',
    },
  },
  edit: BannerEdit,
  save: ({ attributes }) => {
    const {
      banners,
      topEnabled,
      topTitle,
      topDescription,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
    } = attributes;

    const getBannerClasses = (type, contentPosition) => {
      switch (type) {
        case 'banner-full':
          return `banner banner-full ${contentPosition}`;
        case 'banner-col-1':
          return `banner banner-col-1 ${contentPosition}`;
        case 'banner-col-2':
          return `banner banner-col-2 ${contentPosition}`;
        default:
          return '';
      }
    };

    const darkMode = sectionClass.includes('light');

    return (
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${sectionClass.replace(
            'section',
            'corner'
          )} ${cornerBackgroundClass}`}
        ></div>
        <div className="banners-section-wrapper">
          <div className="content-container">
            {topEnabled && (
              <div className="top">
                <RichText.Content tagName="h2" value={topTitle} />
                <div className="description">
                  <RichText.Content tagName="p" value={topDescription} />
                </div>
              </div>
            )}
            <div className="banners-wrapper">
              {banners.map((banner, index) => (
                <div
                  className={getBannerClasses(
                    banner.type,
                    banner.contentPosition
                  )}
                  key={index}
                >
                  <img
                    className={'pg-banners-img-desktop'}
                    src={
                      banner.imgUrl && banner.imgUrl.length
                        ? banner.imgUrl
                        : DEFAULT_IMAGE
                    }
                    alt={
                      banner.imgAlt && banner.imgAlt.length
                        ? banner.imgAlt
                        : banner.title
                    }
                  />
                  <img
                    className={'pg-banners-img-mobile'}
                    src={
                      banner.mobileImgUrl && banner.mobileImgUrl.length
                        ? banner.mobileImgUrl
                        : banner.imgUrl && banner.imgUrl.length
                          ? banner.imgUrl
                          : DEFAULT_IMAGE
                    }
                    alt={
                      banner.mobileImgAlt && banner.mobileImgAlt.lengh
                        ? banner.mobileImgAlt
                        : banner.imgAlt && banner.imgAlt.length
                          ? banner.imgAlt
                          : banner.title
                    }
                  />
                  <div className="content">
                    <RichText.Content
                      tagName="div"
                      className="h2-eyebrow"
                      value={banner.eyebrow}
                    />
                    <RichText.Content tagName="h2" value={banner.title} />
                    <RichText.Content
                      tagName="div"
                      className="description"
                      value={banner.description}
                    />
                    {banner.buttons && (
                      <div className="buttons">
                        {banner.buttons.map((button, bIndex) => (
                          <a
                            key={bIndex}
                            href={button.href}
                            className={`${button.className}`}
                          >
                            {button.text}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  },
});
